import { ButtonMantine, ButtonProps } from '../../../Buttons';
import { Group } from '../../../Layout';

type DrawerFooterProps = {
  primaryButton?: React.ReactNode | React.ReactNode[];
  destructiveButton?: React.ReactNode | React.ReactNode[];
  children?: React.ReactNode | React.ReactNode[];
};
interface ExtendedButtonProps extends ButtonProps {
  onClick?: () => void;
}

const DrawerFooter = ({ primaryButton, destructiveButton, children }: DrawerFooterProps) => {
  return (
    <Group justify="space-between">
      <Group>{destructiveButton}</Group>
      <Group wrap="nowrap" justify="flex-end">
        {children}
        {primaryButton}
      </Group>
    </Group>
  );
};

const DestructiveButton = (props: ExtendedButtonProps) => {
  return <ButtonMantine color="cerise" variant="subtle" fullWidth {...props} />;
};

const PrimaryButton = (props: ExtendedButtonProps) => {
  return <ButtonMantine color="cobalt" variant="filled" fullWidth {...props} />;
};

DrawerFooter.DestructiveButton = DestructiveButton;
DrawerFooter.PrimaryButton = PrimaryButton;

export { DrawerFooter };
